module.exports = __webpack_public_path__ + "img/162.5ef8ab1d.jpg";